export const setLeaderToken = (formData) => {
    return {
        type: 'SET_LEADER_TOKEN',
        payload: formData,
    };
};


export const resetLeaderToken = () => {
    return {
        type: 'RESET',
    }
}